import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { OGTags } from "@/components/OGTags";
import { GetTheLookScene } from "@/components/GetTheLookScene";
import { LOOK_SCENES } from "@/data/lookScenes";

import { routeHead } from "@/lib/routeHead";
import { useToolData } from "@/components/tools/toolUtils";

// Title/description come from scripts/routes.mjs, like the prerendered head.
const head = routeHead("/get-the-look");

const GetTheLook = () => {
  const lookPicks = useToolData<Record<string, string[]>>("look-picks.json");
  return (
  <div className="min-h-screen bg-background">
    <OGTags
      title={head.title}
      description={head.description}
      url="https://loftloom.com/get-the-look"
      canonical="https://loftloom.com/get-the-look"
      image={`https://loftloom.com${LOOK_SCENES[0].image}`}
    />
    <Header />
    <Breadcrumbs items={[{ label: "Get the Look" }]} />

    <main>
    <section className="w-[89%] max-w-[1140px] mx-auto pt-10 pb-6 md:pt-14 md:pb-8 text-center">
      <p className="text-[11px] tracking-[0.3em] uppercase text-muted-foreground font-semibold mb-2">
        Inspiration
      </p>
      <h1 className="font-display text-3xl md:text-5xl tracking-[0.02em] text-foreground">
        Get the Look
      </h1>
      <p className="text-sm md:text-base text-muted-foreground mt-3 max-w-xl mx-auto">
        Rooms we love, tagged piece by piece. Each marker leads to an in-stock
        piece with a similar look, or to its category when no honest match is available.
      </p>
    </section>

    <div className="flex flex-col gap-10 md:gap-16 pb-16">
      {LOOK_SCENES.map((scene, i) => (
        <GetTheLookScene
          key={scene.slug}
          scene={scene}
          priority={i === 0}
          picks={lookPicks?.[scene.slug] ?? scene.hotspots.flatMap((hotspot) => hotspot.productHandle ? [hotspot.productHandle] : [])}
        />
      ))}
    </div>
    </main>

    <Footer />
  </div>
  );
};

export default GetTheLook;
